/* Farmers market page: 7-day forecast (today + 6 days) from the National Weather Service (api.weather.gov).
   Free, no API key; the browser calls NWS directly (CORS is open). Results are cached in localStorage:
   the grid lookup for 30 days, the forecast for 30 minutes. If NWS fails the strip is removed. */
(function () {
  'use strict';
  var el = document.querySelector('[data-fm-wx]');
  if (!el) return;
  var API = 'https://api.weather.gov';
  var PT_TTL = 30 * 864e5, FC_TTL = 30 * 6e4;
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DOW_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  var lat = parseFloat(el.getAttribute('data-lat')), lng = parseFloat(el.getAttribute('data-lng'));
  if (!isFinite(lat) || !isFinite(lng) || (lat === 0 && lng === 0)) { el.remove(); return; }
  // NWS wants at most 4 decimals (more = a redirect); Number() drops trailing zeros the same way NWS does
  var LL = Number(lat.toFixed(4)) + ',' + Number(lng.toFixed(4));
  var marketDays = (el.getAttribute('data-days') || '').split(',').filter(Boolean);
  var openMonths = (el.getAttribute('data-months') || '').split(',').filter(Boolean).map(Number);
  var list = el.querySelector('[data-fm-wx-days]');
  var detail = el.querySelector('[data-fm-wx-detail]');
  var src = el.querySelector('[data-fm-wx-src]');

  // ------------------------------------------------------------------ cache (best effort)
  function cacheGet(key, ttl) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || 'null');
      return v && Date.now() - v.t < ttl ? v.d : null;
    } catch (e) { return null; }
  }
  function cachePut(key, d) {
    try {
      localStorage.setItem(key, JSON.stringify({ t: Date.now(), d: d }));
      for (var i = localStorage.length - 1; i >= 0; i--) {          // drop expired forecasts from other markets
        var k = localStorage.key(i);
        if (k && k !== key && k.indexOf('vg_fm_wx_fc:') === 0) {
          var v = JSON.parse(localStorage.getItem(k) || 'null');
          if (!v || Date.now() - v.t > FC_TTL) localStorage.removeItem(k);
        }
      }
    } catch (e) { /* storage full or blocked */ }
  }

  // ------------------------------------------------------------------ fetch with timeout + one retry
  function getJSON(url, tries) {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctl && setTimeout(function () { ctl.abort(); }, 9000);
    return fetch(url, { headers: { Accept: 'application/geo+json' }, signal: ctl ? ctl.signal : undefined })
      .then(function (r) {
        if (timer) clearTimeout(timer);
        if (r.ok) return r.json();
        var err = new Error('NWS ' + r.status);
        err.retry = r.status >= 500;
        throw err;
      })
      .catch(function (err) {
        if (timer) clearTimeout(timer);
        if ((tries || 0) < 1 && err.retry !== false) {
          return new Promise(function (res) { setTimeout(res, 1500); }).then(function () { return getJSON(url, 1); });
        }
        throw err;
      });
  }

  function points() {
    var key = 'vg_fm_wx_pt:' + LL;
    var hit = cacheGet(key, PT_TTL);
    if (hit) return Promise.resolve(hit);
    return getJSON(API + '/points/' + LL).then(function (j) {
      var p = j && j.properties;
      if (!p || !p.forecast) throw new Error('no forecast for this location');
      var d = { f: p.forecast, tz: p.timeZone || '' };
      cachePut(key, d);
      return d;
    });
  }

  function forecast(pt) {
    var key = 'vg_fm_wx_fc:' + pt.f;
    var hit = cacheGet(key, FC_TTL);
    if (hit) return Promise.resolve(hit);
    return getJSON(pt.f).then(function (j) {
      var props = j && j.properties;
      if (!props || !props.periods || !props.periods.length) throw new Error('empty forecast');
      var d = {
        updated: props.updateTime || props.generatedAt || '',
        periods: props.periods.map(function (p) {
          return { s: p.startTime, n: !p.isDaytime, t: p.temperature, u: p.temperatureUnit || 'F',
            pop: p.probabilityOfPrecipitation && p.probabilityOfPrecipitation.value,
            sf: p.shortForecast || '', df: p.detailedForecast || '' };
        })
      };
      cachePut(key, d);
      return d;
    });
  }

  // ------------------------------------------------------------------ periods -> today + 6 days (market's local dates)
  function localDate(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (x) { o[x.type] = x.value; });
      return o.year + '-' + o.month + '-' + o.day;
    } catch (e) { return ''; }
  }

  function toDays(periods, tz) {
    var today = (tz && localDate(tz)) || periods[0].s.slice(0, 10);
    var byKey = {}, order = [];
    periods.forEach(function (p) {
      var k = p.s.slice(0, 10);                                  // NWS times carry the market's own UTC offset
      if (k < today) return;
      if (!byKey[k]) { byKey[k] = { key: k }; order.push(k); }
      byKey[k][p.n ? 'night' : 'day'] = p;                       // a later night period (e.g. after "Overnight") wins
    });
    return order.slice(0, 7).map(function (k, i) { var d = byKey[k]; d.today = k === today || (i === 0 && !tz); return d; });
  }

  // ------------------------------------------------------------------ icons
  var ICON = {
    sun: '<circle cx="12" cy="12" r="4.2" class="fm-wx__sun"/><path class="fm-wx__sun" d="M12 2.5v2.3M12 19.2v2.3M2.5 12h2.3M19.2 12h2.3M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M5.3 18.7l1.6-1.6M17.1 6.9l1.6-1.6"/>',
    moon: '<path d="M19.5 14.6A7.6 7.6 0 0 1 9.4 4.5a7.6 7.6 0 1 0 10.1 10.1z"/>',
    partly: '<circle cx="8.6" cy="8.6" r="3.2" class="fm-wx__sun"/><path class="fm-wx__sun" d="M8.6 2.4v1.5M2.4 8.6h1.5M4.2 4.2l1.1 1.1M13 4.2l-1.1 1.1"/><path d="M8 19.5h9.2a3.6 3.6 0 0 0 .3-7.2 5 5 0 0 0-9.6 1.4A2.9 2.9 0 0 0 8 19.5z"/>',
    partlynight: '<path d="M11.4 7.3A4.4 4.4 0 0 1 5.6 3.4a4.4 4.4 0 1 0 5.8 3.9z"/><path d="M8 19.5h9.2a3.6 3.6 0 0 0 .3-7.2 5 5 0 0 0-9.6 1.4A2.9 2.9 0 0 0 8 19.5z"/>',
    cloud: '<path d="M7 18.5h10.4a4 4 0 0 0 .4-8 5.6 5.6 0 0 0-10.8 1.6A3.2 3.2 0 0 0 7 18.5z"/>',
    rain: '<path d="M7 14.5h10.4a4 4 0 0 0 .4-8 5.6 5.6 0 0 0-10.8 1.6A3.2 3.2 0 0 0 7 14.5z"/><path class="fm-wx__drop" d="M8.5 17.5l-1 2.5M12.5 17.5l-1 2.5M16.5 17.5l-1 2.5"/>',
    storm: '<path d="M7 14.5h10.4a4 4 0 0 0 .4-8 5.6 5.6 0 0 0-10.8 1.6A3.2 3.2 0 0 0 7 14.5z"/><path class="fm-wx__sun" d="M12.8 15.5l-2.2 3.4h2.6l-1.8 3.1"/>',
    snow: '<path d="M7 14.5h10.4a4 4 0 0 0 .4-8 5.6 5.6 0 0 0-10.8 1.6A3.2 3.2 0 0 0 7 14.5z"/><path class="fm-wx__drop" d="M8 18.2h.01M12 19.8h.01M16 18.2h.01M10 21.5h.01M14 21.5h.01"/>',
    fog: '<path d="M7 12.5h10.4a4 4 0 0 0 .4-8 5.6 5.6 0 0 0-10.8 1.6A3.2 3.2 0 0 0 7 12.5z"/><path d="M4 16h16M6 19.5h12"/>',
    wind: '<path d="M3 9h11a2.5 2.5 0 1 0-2.5-2.5M3 13h15a2.5 2.5 0 1 1-2.5 2.5M3 17h8"/>'
  };
  function iconFor(text, night) {
    var s = (text || '').toLowerCase();
    var k = /thunder|t-storm/.test(s) ? 'storm'
      : /snow|flurr|sleet|\bice\b|freezing|wintry|blizzard/.test(s) ? 'snow'
      : /rain|shower|drizzle/.test(s) ? 'rain'
      : /fog|haze|smoke|mist|dust/.test(s) ? 'fog'
      : /mostly sunny|mostly clear|^sunny|^clear|^fair/.test(s) ? 'sun'
      : /partly|mostly cloudy then|becoming sunny|decreasing clouds/.test(s) ? 'partly'
      : /cloud|overcast/.test(s) ? 'cloud'
      : /wind|breezy|blustery/.test(s) ? 'wind'
      : 'partly';
    if (night && k === 'sun') k = 'moon';
    if (night && k === 'partly') k = 'partlynight';
    return '<svg class="fm-wx__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + ICON[k] + '</svg>';
  }

  // ------------------------------------------------------------------ render
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function render(days, updated, tz) {
    var selected = 0;
    var info = days.map(function (d) {
      var dt = new Date(d.key + 'T12:00:00Z');
      var dow = dt.getUTCDay(), mon = dt.getUTCMonth();
      var main = d.day || d.night;
      var pops = [d.day && d.day.pop, d.night && d.night.pop].filter(function (v) { return typeof v === 'number'; });
      var pop = pops.length ? Math.max.apply(null, pops) : null;
      var market = marketDays.indexOf(DOW[dow]) !== -1 && (!openMonths.length || openMonths.indexOf(mon + 1) !== -1);
      var label = d.today ? (d.day ? 'Today' : 'Tonight') : DOW[dow];
      var full = (d.today ? (d.day ? 'Today, ' : 'Tonight, ') : '') + DOW_LONG[dow] + ' ' + MON[mon] + ' ' + dt.getUTCDate();
      return { d: d, dow: dow, mon: mon, date: dt.getUTCDate(), main: main, pop: pop, market: market, label: label, full: full,
        hi: d.day ? d.day.t : null, lo: d.night ? d.night.t : null };
    });
    list.innerHTML = info.map(function (x, i) {
      var temps = x.hi != null
        ? '<span class="fm-wx__hi">' + esc(x.hi) + '°</span><span class="fm-wx__lo">' + (x.lo != null ? esc(x.lo) + '°' : '') + '</span>'
        : '<span class="fm-wx__hi fm-wx__hi--night">' + esc(x.lo) + '°</span><span class="fm-wx__lo">low</span>';
      var aria = x.full + ': ' + x.main.sf + (x.hi != null ? ', high ' + x.hi + '°' : '') + (x.lo != null ? ', low ' + x.lo + '°' : '')
        + (x.pop != null && x.pop >= 20 ? ', ' + x.pop + '% chance of precipitation' : '') + (x.market ? '. Market day' : '');
      return '<li class="fm-wx__day' + (x.market ? ' is-market' : '') + '">'
        + '<button type="button" class="fm-wx__btn" aria-pressed="' + (i === selected) + '" aria-label="' + esc(aria) + '" title="' + esc(x.main.sf) + '" data-i="' + i + '">'
        + '<span class="fm-wx__tag">' + (x.market ? 'Market' : '') + '</span>'
        + '<span class="fm-wx__dow">' + esc(x.label) + '</span>'
        + iconFor(x.main.sf, !x.d.day)
        + temps
        + '<span class="fm-wx__pop">' + (x.pop != null && x.pop >= 20 ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3.5s-6 6.6-6 10.6a6 6 0 0 0 12 0c0-4-6-10.6-6-10.6z"/></svg>' + esc(x.pop) + '%' : '') + '</span>'
        + '</button></li>';
    }).join('');

    function show(i) {
      var x = info[i];
      Array.prototype.forEach.call(list.querySelectorAll('.fm-wx__btn'), function (b, k) { b.setAttribute('aria-pressed', String(k === i)); });
      var parts = [];
      if (x.d.day) parts.push(x.d.day.df);
      if (x.d.night) parts.push((x.d.day ? 'Night: ' : '') + x.d.night.df);
      detail.innerHTML = '<strong>' + esc(x.full) + (x.market ? ' · market day' : '') + ':</strong> ' + esc(parts.join(' '));
    }
    list.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.fm-wx__btn');
      if (b) show(Number(b.getAttribute('data-i')));
    });
    show(selected);

    var when = '';
    try {
      if (updated) when = new Date(updated).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: tz || undefined, timeZoneName: 'short' });
    } catch (e) { when = ''; }
    src.innerHTML = '<a href="https://forecast.weather.gov/MapClick.php?lat=' + encodeURIComponent(lat.toFixed(4)) + '&lon=' + encodeURIComponent(lng.toFixed(4))
      + '" target="_blank" rel="noopener">National Weather Service</a>' + (when ? ' · updated ' + esc(when) : '');
    el.classList.remove('is-loading');
    el.removeAttribute('aria-busy');
    // Market claim: the manager's rain/heat plan (snippets/fm-mgr-weather) reacts to market days in the forecast.
    var pub = info.map(function (x) { return { market: x.market, pop: x.pop, hi: x.hi, sf: x.main.sf, day: x.d.today ? 'today' : DOW_LONG[x.dow] }; });
    el._fmwx = pub;
    try { document.dispatchEvent(new CustomEvent('fm:wx', { detail: pub })); } catch (e) {}
  }

  var tz = '';
  points()
    .then(function (pt) { tz = pt.tz; return forecast(pt); })
    .then(function (fc) {
      var days = toDays(fc.periods, tz);
      if (!days.length) throw new Error('no days');
      render(days, fc.updated, tz);
    })
    .catch(function () { el.remove(); });
})();
